import(/* webpackMode: "eager", webpackExports: ["WithdrawalView"] */ "/web/src/sections/sub-pages/operation/withdrawal/view/withdrawal-view.tsx");
